<template>
  <div id="app">
    <!-- 网站头部 -->
    <header class="app-header">
      <h1 class="app-title">费用分摊计算器</h1>
      <p class="app-subtitle">fee-splitter.hao430.xyz</p>
    </header>
    
    <!-- 引入费用分摊核心组件 -->
    <main class="app-main">
      <CostCalculator />
    </main>
    
    <!-- 网站底部 -->
    <footer class="app-footer">
      <div class="footer-content">
        <p class="repo-info">仓库名：fee-splitter</p>
        <p class="beian-info">
          <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">
            湘ICP备2025125191号
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
// 导入自定义组件
import CostCalculator from './components/CostCalculator.vue'

export default {
  name: 'App',
  components: {
    CostCalculator // 注册组件
  }
}
</script>

<style>
/* 基础样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  font-size: 16px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
}

.app-header {
  background-color: #42b983;
  color: white;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.app-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.app-subtitle {
  margin: 5px 0 0 0;
  font-size: 12px;
  opacity: 0.9;
}

.app-main {
  flex: 1;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
}

.app-footer {
  background-color: #f5f5f5;
  padding: 15px;
  margin-top: 30px;
  border-top: 1px solid #eaeaea;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  color: #666;
}

.repo-info {
  margin: 0;
}

.beian-info {
  margin: 0;
}

.beian-link {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.beian-link:hover {
  color: #42b983;
  text-decoration: underline;
}

/* 移动端适配 */
@media (max-width: 750px) {
  html, body {
    font-size: 14px;
  }
  
  .app-header {
    padding: 12px;
    margin-bottom: 15px;
  }
  
  .app-title {
    font-size: 18px;
  }
  
  .app-subtitle {
    font-size: 11px;
  }
  
  .app-main {
    padding: 0 10px;
  }
  
  .app-footer {
    padding: 12px;
    margin-top: 20px;
  }
  
  .footer-content {
    gap: 10px;
    font-size: 11px;
    flex-direction: column;
  }
}

/* 小屏手机适配 */
@media (max-width: 320px) {
  html, body {
    font-size: 13px;
  }
  
  .app-header {
    padding: 10px;
  }
  
  .app-title {
    font-size: 16px;
  }
  
  .app-subtitle {
    font-size: 10px;
  }
  
  .app-main {
    padding: 0 8px;
  }
}
</style>